import { AxiosError, AxiosResponse } from "axios";
import {
  IChangePassword,
  ICreateOtpByMessege,
  ISignInRequest,
  ISignInResponse,
  IUpdateActiveSessionTime,
  IVerifyOtpByMessege,
} from "../models";
import {
  ICreateAnAccountForm,
  ICreateAnUserForm,
} from "../components/CreateAnAccount";
import {
  ICreateNewPasswordForm,
  IForgotPasswordForm,
} from "../components/ForgotPassword";
import { IResponse, IServerError } from "../models/common";

import { IUserAuthentication } from "../components/UserAuthentication";
import { LocalStorageService } from "./LocalStorageService";
import http from "../common/http-commons";

// import { IRegister, IRegisterResponse } from "components/CreateAnAccount/IRegister";
const extractErrorMessage = (error: unknown): string => {
  const axiosError = error as AxiosError;
  console.error("An error occurred:", axiosError);
  return axiosError.response && typeof axiosError.response.data === "string"
    ? axiosError.response.data
    : "Unknown error";
};

const requestResponse = async <T = any>(url: string): Promise<T | null> => {
  try {
    const response: AxiosResponse<T> = await http.get<T>(url);
    return response.status === 200 ? response.data : null;
  } catch (error) {
    console.error(`Request failed: ${url}`, extractErrorMessage(error));
    return null;
  }
};
export const AuthService = {
  signIn: async (requestPayload: ISignInRequest): Promise<ISignInResponse> => {
    let loginDetail: ISignInRequest = {
      ...requestPayload,
    };

    const response = await http.post<ISignInResponse>(
      "/v1/user/login",
      loginDetail,
    );
    if (response.status === 200) {
      LocalStorageService.setUser(response.data);
      return response.data;
    }

    return response.data;
  },

  CreateOtpByMessege: async (accessToken: any): Promise<ISignInResponse> => {
    const response = await http.post<ISignInResponse>(
      `/v1/user/create-otp_for_user_login?access_token=${accessToken}`,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  CreateOtpByMessegeForPhoneNumberSave: async (
    requestPayload: any,
  ): Promise<ISignInResponse> => {
    const response = await http.put<ISignInResponse>(
      "/v1/user/add_phone_number",
      requestPayload,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  GetAvailable2FAMethods: async (
    accessToken: any,
  ): Promise<ISignInResponse> => {
    const response = await http.get<ISignInResponse>(
      `/v1/user/check_default/${accessToken}/and_other_method`,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  VerifyOtpByMessegeForPhoneNumberSave: async (
    requestPayload: any,
  ): Promise<ISignInResponse> => {
    const response = await http.put<ISignInResponse>(
      "/v1/user/phone_number/otp/",
      requestPayload,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  verifyOtpByMessege: async (requestPayload: any): Promise<ISignInResponse> => {
    let verifyOtpDetail: IVerifyOtpByMessege = {
      ...requestPayload,
    };

    const response = await http.post<ISignInResponse>(
      "/v1/user/verify-otp_for_user_login/",
      verifyOtpDetail,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  verifyQrCode: async (
    requestPayload: IVerifyOtpByMessege,
  ): Promise<ISignInResponse> => {
    let verifyOtpDetail: IVerifyOtpByMessege = {
      ...requestPayload,
    };

    const response = await http.put<ISignInResponse>(
      `/v1/user/${requestPayload.accessToken}/verify-google_auth_otp`,
      verifyOtpDetail,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  GenerateQrCode: async (accessToken: any): Promise<any> => {
    const response = await http.get<any>(
      `/v1/user/connect/with_google_authenticator?access_token=${accessToken}`,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  ConnectWithGoogleAuth: async (accessToken: any): Promise<any> => {
    const response = await http.get<any>(
      "/v1/user-token/connect_with_google_authenticator/with_token/",
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  changePassword: async (payload: IChangePassword): Promise<any> => {
    const response = await http.post<IChangePassword>(
      "/v1/user-token/change-password",
      payload,
    );

    if (response.status === 201) {
      return response.data;
    }

    return response.data;
  },

  changePhoneNumber: async (payload: any): Promise<any> => {
    const response = await http.post<any>(
      "/v1/user-token/change_phone_number",
      payload,
    );

    if (response.status === 201) {
      return response.data;
    }

    return response.data;
  },

  disconnectGoogleOrPhone: async (auth_type: any): Promise<any> => {
    const response = await http.post<any>(
      `/v1/user-token/disconnect_google_and_phone/${auth_type}/`,
    );

    if (response.status === 201) {
      return response.data;
    }

    return response.data;
  },

  generateBackupCodeData: async (payload_data: any): Promise<any> => {
    const response = await http.post<any>(
      `/v1/user/generate_backup_codes/for_2fa?otp=${payload_data.otp}`,
    );

    if (response.status === 201) {
      return response.data;
    }

    return response.data;
  },

  UpdateActiveSessionTime: async (
    payload: IUpdateActiveSessionTime,
  ): Promise<any> => {
    const response = await http.post<IUpdateActiveSessionTime>(
      "/v1/user-token/active-session-time",
      payload,
    );

    if (response.status === 201) {
      return response.data;
    }

    return response.data;
  },

  updateSessionTime: async (accessToken: any): Promise<any> => {
    const response = await http.get<any>(
      `/v1/user/connect/with_google_authenticator?access_token=${accessToken}`,
    );
    if (response.status === 200) {
      return response.data;
    }

    return response.data;
  },

  signOut: async () => {
    // localStorage.clear();
    try {
      const response: any = await http.get<any>("/v1/user/logout");
      if (response.status === 200) return response.data;
      else if (response.status === 401) return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      return {
        status: false,
        message: axiosError.response
          ? axiosError.response.data
          : "Unknown error",
      };
    }
  },
  maskData: async () => {
    const responseMaskData: any = await http.put<any>("/v1/mask-unmask/");
    if (responseMaskData.status === 200) return responseMaskData.data;
  },
  getMaskStatus: async () => {
    const responseMaskStatus: any = await http.get<any>("/v1/mask-unmask/");
    if (responseMaskStatus.status === 200)
      return responseMaskStatus.data.maskedStatus;
  },
  register: async (
    requestPayload: ICreateAnAccountForm,
  ): Promise<ICreateAnAccountForm | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<ICreateAnAccountForm> =
        await http.post<ICreateAnAccountForm>(
          "/v1/user/register",
          requestPayload,
        );

      if (response.status === 201) {
        return response.data;
      } else if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  registerUser: async (
    requestPayload: ICreateAnUserForm,
  ): Promise<ICreateAnUserForm | IServerError | IResponse> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<ICreateAnUserForm> =
          await http.put<ICreateAnUserForm>(
            `/v1/user/${requestPayload.id}/`,
            requestPayload,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return { status: false, message: errorMessage, error: true };
      }
    }
    try {
      const response: AxiosResponse<ICreateAnUserForm> =
        await http.post<ICreateAnUserForm>(
          "/v1/user/register-user/by-user",
          requestPayload,
        );

      if (response.status === 201) {
        return response.data;
      } else if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  authenticationData: async (
    key: string | undefined,
  ): Promise<any | IServerError | IResponse> => {
    if (key) {
      try {
        const response: AxiosResponse<any> = await http.get<any>(
          `/v1/user/user_detail/${key}`,
        );

        if (response.status === 200) {
          localStorage.setItem("accessToken", response.data.accessToken);
          return response.data;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        } else {
          return response.data;
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        return {
          status: false,
          message: axiosError.response
            ? axiosError.response.data
            : "Unknown error",
        };
      }
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  verifyEmail: async (
    key: string | undefined,
  ): Promise<any | IServerError | IResponse> => {
    try {
      if (key) {
        let payload = {
          email: key,
        };
        const response: AxiosResponse<ICreateAnAccountForm> =
          await http.post<ICreateAnAccountForm>(
            "/v1/user/verify-email",
            payload,
          );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response;
        } else if (response.status === 404) {
          return response;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  authentication: async (
    requestPayload: IUserAuthentication | any,
  ): Promise<IUserAuthentication | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<IUserAuthentication> =
        await http.post<IUserAuthentication>(
          "/v1/user/forgot-password",
          requestPayload,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  forgetPassword: async (
    requestPayload: IForgotPasswordForm | ICreateNewPasswordForm | any,
  ): Promise<
    IForgotPasswordForm | IServerError | IResponse | ICreateNewPasswordForm
  > => {
    if (requestPayload.key) {
      try {
        let payload = {
          // email: requestPayload.email,
          randomKey: requestPayload.key,
          newPassword: requestPayload.newPassword,
          confirmNewPassword: requestPayload.confirmNewPassword,
        };

        const response: AxiosResponse<IForgotPasswordForm> =
          await http.post<IForgotPasswordForm>(
            "/v1/user/forgot-password",
            payload,
          );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return { status: false, message: errorMessage, error: true };
      }
    }
    try {
      const response: AxiosResponse<IForgotPasswordForm> =
        await http.post<IForgotPasswordForm>(
          `/v1/user/send-email?email=${requestPayload.email}`,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },

  getRoleMenuAndPermissions: async (
    isApiCalls: boolean,
    roleIds: { id: string; expiresAt: string | null }[],
    clientId: string,
    accountantId: string,
    isAdminUser: number,
    companyAccountantName: string | null,
  ): Promise<any | null> => {
    if (!isApiCalls) return null;
    if (companyAccountantName !== null) return null;
    try {
      const response = await http.put<ISignInResponse>(
        `/v1/assign-screens-permissions/screens_and_menu/?client_id=${
          clientId ? clientId : null
        }&accountant_id=${accountantId ? accountantId : null}&super_status=${isAdminUser}`,
        { roleData: roleIds },
      );
      if (response.status === 200) {
        return response.data;
      }

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }

    return {
      menu_data: [
        {
          name: "Home",
          menuOrder: 1,
          menuParentId: null,
          items: [
            {
              name: "Dashboard",
              url: "/clients/dashboard",
              menuOrder: 1,
              menuParentId: "695cdf1ee18e1a110929b0b4",
            },
            {
              name: "Global Search",
              url: "/global-search",
              menuOrder: 1,
              menuParentId: "695cdf1ee18e1a110929b0b4",
            },
            {
              name: "Client List",
              url: "/clients",
              menuOrder: 2,
              menuParentId: "695cdf1ee18e1a110929b0b4",
            },
          ],
        },
        {
          name: "Company",
          menuOrder: 2,
          menuParentId: null,
          items: [
            {
              name: "Setup",
              url: "/clients/setup",
              menuOrder: 1,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Bank",
              url: "/clients/bank-setup",
              menuOrder: 2,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Payroll Schedule",
              url: "/company/payroll-schedule",
              menuOrder: 3,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Filing Resource",
              url: "/company/filing-resources/setup",
              menuOrder: 4,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Departments",
              url: "/company/departments/setup",
              menuOrder: 5,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Designation",
              url: "/company/designation/setup",
              menuOrder: 6,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Locations",
              url: "/company/locations/setup",
              menuOrder: 7,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Teams",
              url: "/company/teams/setup",
              menuOrder: 8,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "Expense Category",
              url: "/company/expense-category/setup",
              menuOrder: 9,
              menuParentId: "695cdf35e18e1a110929b0b6",
            },
            {
              name: "EDR",
              menuOrder: 10,
              menuParentId: "695cdf35e18e1a110929b0b6",
              items: [
                {
                  name: "Earnings",
                  url: "/company/earnings/setup",
                  menuOrder: 1,
                  menuParentId: "695ce6c3e18e1a110929b0f0",
                },
                {
                  name: "Deductions",
                  url: "/company/deductions/setup",
                  menuOrder: 2,
                  menuParentId: "695ce6c3e18e1a110929b0f0",
                },
                {
                  name: "Reimbursements",
                  url: "/company/reimbursements/setup",
                  menuOrder: 3,
                  menuParentId: "695ce6c3e18e1a110929b0f0",
                },
              ],
            },
          ],
        },
        {
          name: "Employee",
          menuOrder: 3,
          menuParentId: null,
          items: [
            {
              name: "List",
              url: "/employee/list",
              menuOrder: 1,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Setup",
              url: "/employee/setup",
              menuOrder: 2,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Bank",
              url: "/employee/bank-setup",
              menuOrder: 3,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Salary",
              url: "/employee/salary-profile",
              menuOrder: 4,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Status",
              url: "/employee/status",
              menuOrder: 5,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Assignment",
              url: "/employee/assignment",
              menuOrder: 6,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Import",
              url: "/employee/import",
              menuOrder: 7,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Draft",
              url: "/employee/draft",
              menuOrder: 8,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
            {
              name: "Payday Advance",
              url: "/employee/payday-advance",
              menuOrder: 9,
              menuParentId: "695cdf46e18e1a110929b0b8",
            },
          ],
        },
        {
          name: "Payroll",
          menuOrder: 4,
          menuParentId: null,
          items: [
            {
              name: "Payroll",
              url: "/payroll",
              menuOrder: 1,
              menuParentId: "695cdf54e18e1a110929b0ba",
            },
            {
              name: "Adjustment",
              url: "/payroll/adjustment",
              menuOrder: 2,
              menuParentId: "695cdf54e18e1a110929b0ba",
            },
            {
              name: "Off-Cycle",
              url: "/payroll/off-cycle",
              menuOrder: 3,
              menuParentId: "695cdf54e18e1a110929b0ba",
            },
            {
              name: "Wire Transfer",
              url: "/payroll/wire-transfer",
              menuOrder: 5,
              menuParentId: "695cdf54e18e1a110929b0ba",
            },
          ],
        },
        {
          name: "Taxes",
          menuOrder: 5,
          menuParentId: null,
          items: [
            {
              name: "Remittance",
              menuOrder: 1,
              menuParentId: "695cdf67e18e1a110929b0bc",
              items: [
                {
                  name: "CRA",
                  url: "/taxes/remittance/cra",
                  menuOrder: 1,
                  menuParentId: "6960a221ade98283c4cf8494",
                },
                {
                  name: "CRA Credit",
                  url: "/taxes/remittance/cra-credit",
                  menuOrder: 2,
                  menuParentId: "6960a221ade98283c4cf8494",
                },
                {
                  name: "RQ",
                  url: "/taxes/remittance/rq",
                  menuOrder: 3,
                  menuParentId: "6960a221ade98283c4cf8494",
                },
              ],
            },
            {
              name: "EHT",
              menuOrder: 3,
              menuParentId: "695cdf67e18e1a110929b0bc",
              items: [
                {
                  name: "Ontario",
                  url: "/taxes/eht/ontario",
                  menuOrder: 1,
                  menuParentId: "6960a24dade98283c4cf84ad",
                },
                {
                  name: "British Columbia",
                  url: "/taxes/eht/bc_eht",
                  menuOrder: 2,
                  menuParentId: "6960a24dade98283c4cf84ad",
                },
              ],
            },
          ],
        },
        {
          name: "WCB/WSIB",
          menuOrder: 6,
          menuParentId: null,
          items: [
            {
              name: "Alberta",
              menuOrder: 1,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/alberta",
                  menuOrder: 1,
                  menuParentId: "69e090445f4ea93222176f86",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/alberta",
                  menuOrder: 2,
                  menuParentId: "69e090445f4ea93222176f86",
                },
              ],
            },
            {
              name: "British Columbia",
              menuOrder: 2,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/british_columbia",
                  menuOrder: 1,
                  menuParentId: "69e0907a5f4ea93222176fa1",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/british_columbia",
                  menuOrder: 2,
                  menuParentId: "69e0907a5f4ea93222176fa1",
                },
              ],
            },
            {
              name: "Manitoba",
              menuOrder: 3,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/manitoba",
                  menuOrder: 1,
                  menuParentId: "69e090935f4ea93222176fbc",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/manitoba",
                  menuOrder: 2,
                  menuParentId: "69e090935f4ea93222176fbc",
                },
              ],
            },
            {
              name: "New Brunswick",
              menuOrder: 4,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/new_brunswick",
                  menuOrder: 1,
                  menuParentId: "69e090a45f4ea93222176fd7",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/new_brunswick",
                  menuOrder: 2,
                  menuParentId: "69e090a45f4ea93222176fd7",
                },
              ],
            },
            {
              name: "Newfoundland and Labrador",
              menuOrder: 5,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/newfoundland_and_labrador",
                  menuOrder: 1,
                  menuParentId: "69e090b15f4ea93222176ff2",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/newfoundland_and_labrador",
                  menuOrder: 2,
                  menuParentId: "69e090b15f4ea93222176ff2",
                },
              ],
            },
            {
              name: "Northwest Territories",
              menuOrder: 6,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/northwest_territories",
                  menuOrder: 1,
                  menuParentId: "69e090be5f4ea9322217700d",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/northwest_territories",
                  menuOrder: 2,
                  menuParentId: "69e090be5f4ea9322217700d",
                },
              ],
            },
            {
              name: "Nova Scotia",
              menuOrder: 7,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/nova_scotia",
                  menuOrder: 1,
                  menuParentId: "69e090dd5f4ea93222177064",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/nova_scotia",
                  menuOrder: 2,
                  menuParentId: "69e090dd5f4ea93222177064",
                },
              ],
            },
            {
              name: "Nunavut",
              menuOrder: 8,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/nunavut",
                  menuOrder: 1,
                  menuParentId: "69e090e85f4ea932221770a3",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/nunavut",
                  menuOrder: 2,
                  menuParentId: "69e090e85f4ea932221770a3",
                },
              ],
            },
            {
              name: "Ontario",
              menuOrder: 9,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wsib/ontario-code/setup",
                  menuOrder: 1,
                  menuParentId: "69d6367caaa322cab568ae35",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wsib/ontario-remittance",
                  menuOrder: 2,
                  menuParentId: "69d6367caaa322cab568ae35",
                },
              ],
            },
            {
              name: "Prince Edward Island",
              menuOrder: 10,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/prince_edward_island",
                  menuOrder: 1,
                  menuParentId: "69e091015f4ea93222177122",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/prince_edward_island",
                  menuOrder: 2,
                  menuParentId: "69e091015f4ea93222177122",
                },
              ],
            },
            {
              name: "Saskatchewan",
              menuOrder: 11,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/saskatchewan",
                  menuOrder: 1,
                  menuParentId: "69e0910d5f4ea93222177163",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/saskatchewan",
                  menuOrder: 2,
                  menuParentId: "69e0910d5f4ea93222177163",
                },
              ],
            },
            {
              name: "Yukon",
              menuOrder: 12,
              menuParentId: "69e0a26c5f4ea93222177585",
              items: [
                {
                  name: "Code Setup",
                  url: "/taxes/wcb/code/yukon",
                  menuOrder: 1,
                  menuParentId: "69e0911b5f4ea932221771a5",
                },
                {
                  name: "Remittance",
                  url: "/taxes/wcb/remittance/yukon",
                  menuOrder: 2,
                  menuParentId: "69e0911b5f4ea932221771a5",
                },
              ],
            },
          ],
        },
        {
          name: "Compliance",
          menuOrder: 7,
          menuParentId: null,
          items: [
            {
              name: "T4",
              headerLabel: "Slips",
              menuOrder: 1,
              menuParentId: "695cdf7ce18e1a110929b0be",
              items: [
                {
                  name: "List",
                  url: "/compliance/t4/list",
                  menuOrder: 1,
                  menuParentId: "6960a969ade98283c4cf8501",
                },
                {
                  name: "Setup",
                  url: "/compliance/t4/setup",
                  menuOrder: 2,
                  menuParentId: "6960a969ade98283c4cf8501",
                },
                {
                  name: "Summary",
                  url: "/compliance/t4/summary",
                  menuOrder: 3,
                  menuParentId: "6960a969ade98283c4cf8501",
                },
                {
                  name: "Summary Reduced EI",
                  url: "/compliance/t4/summary-reduced-ei",
                  menuOrder: 4,
                  menuParentId: "6960a969ade98283c4cf8501",
                },
              ],
            },
            {
              name: "RL-1",
              menuOrder: 2,
              headerLabel: "Slips",
              menuParentId: "695cdf7ce18e1a110929b0be",
              items: [
                {
                  name: "List",
                  url: "/compliance/rl1/list",
                  menuOrder: 1,
                  menuParentId: "6960a982ade98283c4cf850f",
                },
                {
                  name: "Setup",
                  url: "/compliance/rl1/setup",
                  menuOrder: 2,
                  menuParentId: "6960a982ade98283c4cf850f",
                },
                {
                  name: "Summary",
                  url: "/compliance/rl1/summary",
                  menuOrder: 3,
                  menuParentId: "6960a982ade98283c4cf850f",
                },
                {
                  name: "Settings",
                  url: "/compliance/rl1/settings",
                  menuOrder: 4,
                  menuParentId: "6960a982ade98283c4cf850f",
                },
              ],
            },
            {
              name: "TD1",
              menuOrder: 3,
              headerLabel: "Slips",
              menuParentId: "695cdf7ce18e1a110929b0be",
              items: [
                {
                  name: "Federal",
                  url: "/td1/federal",
                  menuOrder: 1,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "AB",
                  url: "/td1/alberta",
                  menuOrder: 2,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "BC",
                  url: "/td1/british_columbia",
                  menuOrder: 3,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "MB",
                  url: "/td1/manitoba",
                  menuOrder: 4,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "NB",
                  url: "/td1/new_brunswick",
                  menuOrder: 5,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "NL",
                  url: "/td1/newfoundland_and_labrador",
                  menuOrder: 6,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "NT",
                  url: "/td1/northwest_territories",
                  menuOrder: 7,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "NS",
                  url: "/td1/nova_scotia",
                  menuOrder: 8,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "NU",
                  url: "/td1/nunavut",
                  menuOrder: 9,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "ON",
                  url: "/td1/ontario",
                  menuOrder: 10,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "PE",
                  url: "/td1/prince_edward_island",
                  menuOrder: 11,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "QC",
                  url: "/td1/quebec",
                  menuOrder: 12,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "SK",
                  url: "/td1/saskatchewan",
                  menuOrder: 13,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
                {
                  name: "YT",
                  url: "/td1/yukon",
                  menuOrder: 14,
                  menuParentId: "6960a99dade98283c4cf851e",
                },
              ],
            },
            {
              name: "ROE",
              menuOrder: 4,
              headerLabel: "Forms",
              menuParentId: "695cdf7ce18e1a110929b0be",
              items: [
                {
                  name: "List",
                  url: "/compliance/roe/list",
                  menuOrder: 1,
                  menuParentId: "69eb36a7cbead60539301211",
                },
                {
                  name: "Create",
                  url: "/compliance/roe/setup",
                  menuOrder: 2,
                  menuParentId: "69eb36a7cbead60539301211",
                },
                {
                  name: "Web",
                  url: "/compliance/roe/web",
                  menuOrder: 3,
                  menuParentId: "69eb36a7cbead60539301211",
                },
              ],
            },
          ],
        },
        {
          name: "Reports",
          menuOrder: 7,
          menuParentId: null,
          items: [
            {
              name: "Employees",
              menuOrder: 1,
              menuParentId: "6960a1a5ade98283c4cf8450",
              items: [
                {
                  name: "Setup",
                  url: "/reports/employee/setup",
                  menuOrder: 1,
                  menuParentId: "6960a9feade98283c4cf853f",
                },
                {
                  name: "Salary",
                  url: "/reports/salary",
                  menuOrder: 2,
                  menuParentId: "6960a9feade98283c4cf853f",
                },
                {
                  name: "Stub",
                  url: "/reports/stub",
                  menuOrder: 3,
                  menuParentId: "6960a9feade98283c4cf853f",
                },
                {
                  name: "Payday Advance",
                  url: "/reports/payday-advance",
                  menuOrder: 4,
                  menuParentId: "6960a9feade98283c4cf853f",
                },
              ],
            },
            {
              name: "Payroll",
              menuOrder: 2,
              menuParentId: "6960a1a5ade98283c4cf8450",
              items: [
                {
                  name: "Payroll Report",
                  url: "/reports/payroll",
                  menuOrder: 1,
                  menuParentId: "6968e155949fe62caf457705",
                },
                {
                  name: "Payroll Adjustment",
                  url: "/reports/payroll-adjustment",
                  menuOrder: 2,
                  menuParentId: "6968e155949fe62caf457705",
                },
                {
                  name: "EDR",
                  url: "/reports/edr",
                  menuOrder: 3,
                  menuParentId: "6968e155949fe62caf457705",
                },
                {
                  name: "Statutory Holiday",
                  url: "/reports/statutory-holiday",
                  menuOrder: 6,
                  menuParentId: "6968e155949fe62caf457705",
                },
              ],
            },
            {
              name: "Accounting",
              menuOrder: 3,
              menuParentId: "6960a1a5ade98283c4cf8450",
              items: [
                {
                  name: "Invoice",
                  url: "/reports/invoice",
                  menuOrder: 1,
                  menuParentId: "69733df89b395140424b4006",
                },
              ],
            },
            {
              name: "Remittance",
              menuOrder: 4,
              menuParentId: "6960a1a5ade98283c4cf8450",
              items: [
                {
                  name: "EHT Ontario",
                  url: "/reports/eht-ontario",
                  menuOrder: 1,
                  menuParentId: "69b1012eeff27edd1ca56cf3",
                },
                {
                  name: "CRA",
                  url: "/reports/cra",
                  menuOrder: 2,
                  menuParentId: "69b1012eeff27edd1ca56cf3",
                },
                {
                  name: "RQ",
                  url: "/reports/rq",
                  menuOrder: 3,
                  menuParentId: "69b1012eeff27edd1ca56cf3",
                },
                {
                  name: "WSIB",
                  url: "/reports/wsib",
                  menuOrder: 4,
                  menuParentId: "69b1012eeff27edd1ca56cf3",
                },
              ],
            },
            {
              name: "Misc",
              menuOrder: 5,
              menuParentId: "6960a1a5ade98283c4cf8450",
              items: [
                {
                  name: "Year To Date",
                  url: "/reports/year-to-date",
                  menuOrder: 3,
                  menuParentId: "69b0ff85eff27edd1ca56c21",
                },
              ],
            },
            {
              name: "Compliance",
              menuOrder: 6,
              menuParentId: "6960a1a5ade98283c4cf8450",
              items: [
                {
                  name: "T4",
                  url: "/reports/compliance/t4",
                  menuOrder: 1,
                  menuParentId: "69b10173eff27edd1ca56d19",
                },
                {
                  name: "RL1",
                  url: "/reports/compliance/rl1",
                  menuOrder: 2,
                  menuParentId: "69b10173eff27edd1ca56d19",
                },
                {
                  name: "TD1",
                  url: "/reports/compliance/td1",
                  menuOrder: 3,
                  menuParentId: "69b10173eff27edd1ca56d19",
                },
                {
                  name: "ROE",
                  url: "/reports/compliance/roe",
                  menuOrder: 4,
                  menuParentId: "69b10173eff27edd1ca56d19",
                },
              ],
            },
          ],
        },
        {
          name: "User Management",
          menuOrder: 8,
          menuParentId: null,
          items: [
            {
              name: "Users",
              url: "/role-management/users",
              menuOrder: 1,
              menuParentId: "6978e2f2f266faeefdb82f04",
            },
            {
              name: "Role Setup",
              url: "/role-management/role/setup",
              menuOrder: 2,
              menuParentId: "6978e2f2f266faeefdb82f04",
            },
            {
              name: "Role Assignment",
              menuOrder: 3,
              menuParentId: "6978e2f2f266faeefdb82f04",
              items: [
                {
                  name: "List",
                  url: "/role-management/role-assignment",
                  menuOrder: 1,
                  menuParentId: "6978e850a58e6c22211f7fa4",
                },
                {
                  name: "Setup",
                  url: "/role-management/role-assignment/setup",
                  menuOrder: 2,
                  menuParentId: "6978e850a58e6c22211f7fa4",
                },
              ],
            },
          ],
        },
        {
          name: "Settings",
          menuOrder: 10,
          menuParentId: null,
          items: [
            {
              name: "General",
              url: "/settings/general/setup",
              menuOrder: 1,
              menuParentId: "69e727a6f15054e31ac1bf35",
            },
            {
              name: "Stub",
              url: "/settings/stub/setup",
              menuOrder: 2,
              menuParentId: "69e727a6f15054e31ac1bf35",
            },
            {
              name: "Cheque",
              url: "/settings/cheque/setup",
              menuOrder: 3,
              menuParentId: "69e727a6f15054e31ac1bf35",
            },
            {
              name: "Statutory Holiday",
              url: "/settings/statutory-holiday",
              menuOrder: 4,
              menuParentId: "69e727a6f15054e31ac1bf35",
            },
            {
              name: "Year To Date",
              menuOrder: 5,
              menuParentId: "69e727a6f15054e31ac1bf35",
              items: [
                {
                  name: "Payroll Settings",
                  url: "/settings/year-to-date/payroll",
                  menuOrder: 1,
                  menuParentId: "69e727e4f15054e31ac1bf50",
                },
                {
                  name: "Import",
                  url: "/settings/year-to-date/import",
                  menuOrder: 2,
                  menuParentId: "69e727e4f15054e31ac1bf50",
                },
                {
                  name: "Remittance",
                  url: "/settings/year-to-date/remittance",
                  menuOrder: 3,
                  menuParentId: "69e727e4f15054e31ac1bf50",
                },
              ],
            },
          ],
        },
      ],
      screenFirstPoint: null,
      screenPermissions: [
        {
          screenName: "Company > Setup",
          screenId: "6968cba5949fe62caf456df9",
          url: "/clients/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Bank",
          screenId: "6968cf62949fe62caf456dfd",
          url: "/clients/bank-setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Payroll Schedule",
          screenId: "6968cfab949fe62caf456e05",
          url: "/company/payroll-schedule",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Filing Resource",
          screenId: "6968cfcf949fe62caf456e17",
          url: "/company/filing-resources/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Departments",
          screenId: "6968cfe8949fe62caf456e1d",
          url: "/company/departments/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Designation",
          screenId: "6968d005949fe62caf456e24",
          url: "/company/designation/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Locations",
          screenId: "6968d018949fe62caf456e2c",
          url: "/company/locations/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Teams",
          screenId: "6968d03b949fe62caf456e35",
          url: "/company/teams/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > Expense Category",
          screenId: "6968d070949fe62caf456e3f",
          url: "/company/expense-category/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > EDR > Earnings",
          screenId: "6968d0c6949fe62caf456e68",
          url: "/company/earnings/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > EDR > Deductions",
          screenId: "6968d0e3949fe62caf456e74",
          url: "/company/deductions/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Company > EDR > Reimbursements",
          screenId: "6968d10d949fe62caf456e81",
          url: "/company/reimbursements/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > List",
          screenId: "6968d133949fe62caf456e8f",
          url: "/employee/list",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Setup",
          screenId: "6968d158949fe62caf456e9e",
          url: "/employee/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Bank",
          screenId: "6968d174949fe62caf456eae",
          url: "/employee/bank-setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Salary",
          screenId: "6968d1ba949fe62caf456ebf",
          url: "/employee/salary-profile",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Status",
          screenId: "6968d1e6949fe62caf456ed1",
          url: "/employee/status",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Assignment",
          screenId: "6968d2aa949fe62caf456ef6",
          url: "/employee/assignment",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Import",
          screenId: "6968d2c3949fe62caf456f0a",
          url: "/employee/import",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Draft",
          screenId: "6968d2db949fe62caf456f1f",
          url: "/employee/draft",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Employee > Payday Advance",
          screenId: "6968d318949fe62caf456f35",
          url: "/employee/payday-advance",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Payroll > Payroll",
          screenId: "6968d33d949fe62caf456f4c",
          url: "/payroll",
          view: true,
          "Calculate Payroll": true,
          delete: true,
          update: true,
          add: true,
        },
        {
          screenName: "Taxes > Remittance > CRA",
          screenId: "6968d368949fe62caf456f64",
          url: "/taxes/remittance/cra",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Taxes > Remittance > CRA Credit",
          screenId: "6968d37d949fe62caf456f7d",
          url: "/taxes/remittance/cra-credit",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Taxes > Remittance > RQ",
          screenId: "6968d392949fe62caf456f97",
          url: "/taxes/remittance/rq",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Taxes > WCB/WSIB > Ontario",
          screenId: "6968d3d3949fe62caf456fb2",
          url: null,
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Taxes > WCB/WSIB > Alberta",
          screenId: "6968d3e3949fe62caf456fcd",
          url: null,
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Taxes > EHT > Ontario",
          screenId: "6968d400949fe62caf456fe8",
          url: "/taxes/eht/ontario",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Taxes > EHT > British Columbia",
          screenId: "6968d465949fe62caf457021",
          url: "/taxes/eht/bc_eht",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > T4 > List",
          screenId: "6968d484949fe62caf457040",
          url: "/compliance/t4/list",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > T4 > Setup",
          screenId: "6968d49a949fe62caf457060",
          url: "/compliance/t4/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > T4 > Summary",
          screenId: "6968d4ac949fe62caf457081",
          url: "/compliance/t4/summary",
          view: true,
          delete: true,
          update: true,
          add: true,
          "Generate XML": true,
        },
        {
          screenName: "Compliance > T4 > Summary Reduced EI",
          screenId: "6968d4d5949fe62caf4570a4",
          url: "/compliance/t4/summary-reduced-ei",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > RL-1 > List",
          screenId: "6968d4f0949fe62caf4570c7",
          url: "/compliance/rl1/list",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > RL-1 > Setup",
          screenId: "6968d50c949fe62caf4570eb",
          url: "/compliance/rl1/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > RL-1 > Summary",
          screenId: "6968d522949fe62caf457111",
          url: "/compliance/rl1/summary",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > RL-1 > Settings",
          screenId: "6968d58f949fe62caf457144",
          url: "/compliance/rl1/settings",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > Federal",
          screenId: "6968d5a9949fe62caf45716b",
          url: "/td1/federal",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > AB",
          screenId: "6968d5d6949fe62caf457193",
          url: "/td1/alberta",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > BC",
          screenId: "6968d602949fe62caf4571bc",
          url: "/td1/british_columbia",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > MB",
          screenId: "6968d626949fe62caf4571e6",
          url: "/td1/manitoba",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > NB",
          screenId: "6968d640949fe62caf457211",
          url: "/td1/new_brunswick",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > NL",
          screenId: "6968d65f949fe62caf45723d",
          url: "/td1/newfoundland_and_labrador",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > NT",
          screenId: "6968d67d949fe62caf45726a",
          url: "/td1/northwest_territories",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > NS",
          screenId: "6968d695949fe62caf457298",
          url: "/td1/nova_scotia",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > NU",
          screenId: "6968d6c1949fe62caf4572c7",
          url: "/td1/nunavut",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > ON",
          screenId: "6968d702949fe62caf457355",
          url: "/td1/ontario",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > PE",
          screenId: "6968d725949fe62caf457386",
          url: "/td1/prince_edward_island",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > QC",
          screenId: "6968d73b949fe62caf4573b8",
          url: "/td1/quebec",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > SK",
          screenId: "6968d756949fe62caf4573eb",
          url: "/td1/saskatchewan",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > TD1 > YT",
          screenId: "6968d781949fe62caf45741f",
          url: "/td1/yukon",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > ROE > List",
          screenId: "6968d7d2949fe62caf4574ba",
          url: "/compliance/roe/list",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > ROE > Create",
          screenId: "6968d7ef949fe62caf4574f0",
          url: "/compliance/roe/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Employees > Setup",
          screenId: "6968d82d949fe62caf45755f",
          url: "/reports/employee/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Employees > Salary",
          screenId: "6968d84a949fe62caf457598",
          url: "/reports/salary",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Payroll > EDR",
          screenId: "6968e20b949fe62caf457751",
          url: "/reports/edr",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Remittance > EHT Ontario",
          screenId: "6968e22b949fe62caf45776c",
          url: "/reports/eht-ontario",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Remittance > CRA",
          screenId: "6968e255949fe62caf457787",
          url: "/reports/cra",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Remittance > RQ",
          screenId: "6968e26e949fe62caf4577a2",
          url: "/reports/rq",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Compliance > T4",
          screenId: "6968e2c1949fe62caf4577bd",
          url: "/reports/compliance/t4",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Compliance > RL1",
          screenId: "6968e2dd949fe62caf4577d8",
          url: "/reports/compliance/rl1",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Compliance > TD1",
          screenId: "6968e354949fe62caf45780d",
          url: "/reports/compliance/td1",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Home > Dashboard",
          screenId: "6968e6f5949fe62caf457870",
          url: "/clients/dashboard",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Home > Client List",
          screenId: "696f29a31b737e8f5142a02b",
          url: "/clients",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Accounting > Invoice",
          screenId: "69733e399b395140424b403a",
          url: "/reports/invoice",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "User Management > Users",
          screenId: "697885cbd91d054030404c92",
          url: "/role-management/users",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "User Management > Role Assignment > List",
          screenId: "6978870cd91d054030404e12",
          url: "/role-management/role-assignment",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "User Management > Role Assignment > Setup",
          screenId: "69788723d91d054030404e2b",
          url: "/role-management/role-assignment/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Compliance > ROE > Web",
          screenId: "69788c930b18251c4f138fe9",
          url: "/compliance/roe/web",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "User Management > Role Setup",
          screenId: "6978d75f5ebe6a7fda36e07e",
          url: "/role-management/role/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Home > Client Setup",
          screenId: "697c64285fd484fbe8438518",
          url: "/clients/setup",
          add: false,
          view: false,
          delete: false,
          update: false,
        },
        {
          screenName: "Reports > Payroll > Payroll Report",
          screenId: "69a9184d1c152af1e8c3e832",
          url: "/reports/payroll",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Employees > Stub",
          screenId: "69abdbe6bca94cb03d4cae8c",
          url: "/reports/stub",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Employees > Payday Advance",
          screenId: "69abdc03bca94cb03d4caea7",
          url: "/reports/payday-advance",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Misc > Year To Date",
          screenId: "69b0ffc4eff27edd1ca56c55",
          url: "/reports/year-to-date",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Payroll > Payroll Adjustment",
          screenId: "69cb6882c4f9a22ec35d3e66",
          url: "/reports/payroll-adjustment",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Payroll > Adjustment",
          screenId: "69cba873c4f9a22ec35d3f03",
          url: "/payroll/adjustment",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Ontario",
          screenId: "6968d3e3949fe62caf456fcd",
          url: "/taxes/wcb/code/alberta",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Payroll > Off-Cycle Payroll",
          screenId: "69d8df513cc6b0e03c1039aa",
          url: "/payroll/off-cycle",
          add: false,
          view: false,
          delete: false,
          update: false,
        },
        {
          screenName: "WCB/WSIB > Alberta > Code Setup",
          screenId: "69e093685f4ea93222177266",
          url: "/taxes/wcb/code/alberta",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Alberta > Remittance",
          screenId: "69e093b35f4ea93222177281",
          url: "/taxes/wcb/remittance/alberta",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > British Columbia > Code Setup",
          screenId: "69e093d95f4ea9322217729c",
          url: "/taxes/wcb/code/british_columbia",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > British Columbia > Remittance",
          screenId: "69e093f15f4ea932221772b7",
          url: "/taxes/wcb/remittance/british_columbia",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Manitoba > Code Setup",
          screenId: "69e094125f4ea932221772d2",
          url: "/taxes/wcb/code/manitoba",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Manitoba > Remittance",
          screenId: "69e094225f4ea932221772ed",
          url: "/taxes/wcb/remittance/manitoba",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > New Brunswick > Code Setup",
          screenId: "69e094395f4ea93222177308",
          url: "/taxes/wcb/code/new_brunswick",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > New Brunswick > Remittance",
          screenId: "69e0944c5f4ea93222177323",
          url: "/taxes/wcb/remittance/new_brunswick",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Newfoundland and Labrador > Code Setup",
          screenId: "69e094615f4ea9322217733e",
          url: "/taxes/wcb/code/newfoundland_and_labrador",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Newfoundland and Labrador > Remittance",
          screenId: "69e094735f4ea93222177359",
          url: "/taxes/wcb/remittance/newfoundland_and_labrador",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Northwest Territories > Code Setup",
          screenId: "69e0948d5f4ea93222177374",
          url: "/taxes/wcb/code/northwest_territories",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Northwest Territories > Remittance",
          screenId: "69e094a55f4ea9322217738f",
          url: "/taxes/wcb/remittance/northwest_territories",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Nova Scotia > Code Setup",
          screenId: "69e094c05f4ea932221773aa",
          url: "/taxes/wcb/code/nova_scotia",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Nova Scotia > Remittance",
          screenId: "69e094d15f4ea932221773c5",
          url: "/taxes/wcb/remittance/nova_scotia",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Nunavut > Code Setup",
          screenId: "69e094ea5f4ea932221773e0",
          url: "/taxes/wcb/code/nunavut",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Nunavut > Remittance",
          screenId: "69e095035f4ea932221773fb",
          url: "/taxes/wcb/remittance/nunavut",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Prince Edward Island > Code Setup",
          screenId: "69e0951d5f4ea93222177416",
          url: "/taxes/wcb/code/prince_edward_island",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Prince Edward Island > Remittance",
          screenId: "69e0952f5f4ea93222177431",
          url: "/taxes/wcb/remittance/prince_edward_island",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Saskatchewan > Code Setup",
          screenId: "69e095475f4ea9322217744c",
          url: "/taxes/wcb/code/saskatchewan",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Saskatchewan > Remittance",
          screenId: "69e095585f4ea93222177467",
          url: "/taxes/wcb/remittance/saskatchewan",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Yukon > Code Setup",
          screenId: "69e0956a5f4ea93222177482",
          url: "/taxes/wcb/code/yukon",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Yukon > Remittance",
          screenId: "69e095795f4ea9322217749d",
          url: "/taxes/wcb/remittance/yukon",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Ontario > Code Setup",
          screenId: "69e095ae5f4ea932221774b8",
          url: "/taxes/wsib/ontario-code/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "WCB/WSIB > Ontario > Remittance",
          screenId: "69e095cd5f4ea932221774d3",
          url: "/taxes/wsib/ontario-remittance",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Settings > General",
          screenId: "69e7284df15054e31ac1bf84",
          url: "/settings/general/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Settings > Stub",
          screenId: "69e72862f15054e31ac1bf9f",
          url: "/settings/stub/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Settings > Cheque",
          screenId: "69e7287cf15054e31ac1bfba",
          url: "/settings/cheque/setup",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Settings > Statutory Holiday",
          screenId: "69e72891f15054e31ac1bfd5",
          url: "/settings/statutory-holiday",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Settings > Year To Date > Payroll Settings",
          screenId: "69e72927f15054e31ac1bff0",
          url: "/settings/year-to-date/payroll",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Settings > Year To Date > Import",
          screenId: "69e7293ef15054e31ac1c00b",
          url: "/settings/year-to-date/import",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Settings > Year To Date > Remittance",
          screenId: "69e72966f15054e31ac1c026",
          url: "/settings/year-to-date/remittance",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Compliance > ROE",
          screenId: "69eb342acbead605393011dc",
          url: "/reports/compliance/roe",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Payroll > Off-Cycle",
          screenId: "69ef46b9a576d5ea0eb0b34c",
          url: "/payroll/off-cycle",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Remittance > WSIB",
          screenId: "69f32a00f8654cf9ec66908b",
          url: "/reports/wsib",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Payroll > Wire Transfer",
          screenId: "6a0daec92485d9ea7589107a",
          url: "/payroll/wire-transfer",
          add: true,
          view: true,
          delete: true,
          update: true,
        },
        {
          screenName: "Reports > Payroll > Statutory Holiday",
          screenId: "6a4b67d40cde504e37f2b1fb",
          url: "/reports/statutory-holiday",
          view: true,
          add: true,
          delete: true,
          update: true,
        },
      ],
    };
  },
  saveSecurityQuestions: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/security-question/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  uploadDocumentData: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<any>(
          `/v1/accountant-bank-file-save/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 201) {
          return response;
        } else if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return { status: false, message: errorMessage, error: true };
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/accountant-bank-file-save/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  deleteUploadedDocument: async (
    id: string | null,
  ): Promise<string | IServerError | IResponse | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/accountant-bank-file-save/${id}/`,
      );

      if (response.status === 204) {
        return "Departments has been deleted successfully";
      } else if (response.status === 200) {
        return "Departments has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
  getPADAgreenmentBankDetails: async (
    parentId: string | null,
    bankId: string | null, // accessToken: any,
  ): Promise<ISignInResponse | null> => {
    if (!parentId) return null;
    if (!bankId) return null;
    try {
      const response = await http.get<ISignInResponse>(
        `/v1/pad-agreement/${parentId}/?bank_id=${bankId}`,
      );
      if (response.status === 200) {
        return response.data;
      }

      return response.data;
    } catch {
      return null;
    }
  },
  getUploadedDocumetnsDetails: async (
    parentId: string | null,
    bankId: string | null, // accessToken: any,
  ): Promise<ISignInResponse | null> => {
    if (!parentId) return null;
    if (!bankId) return null;
    try {
      const response = await http.get<ISignInResponse>(
        `/v1/accountant-bank-file-save/${parentId}/?bank_id=${bankId}`,
      );
      if (response.status === 200) {
        return response.data;
      }

      return response.data;
    } catch {
      return null;
    }
  },
  savePADAgreenment: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/pad-agreement/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  sendForVerificationPADAgreenment: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/pad-agreement/verify/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  getProvinceOrStateDDL: async (
    countryId: string,
    countryTag: string,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (countryTag === "Province" || countryTag === "province") {
      try {
        const response: AxiosResponse<any> = await http.get<any>(
          `/v1/Province/ddl?country_id=${countryId}`,
        );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";

        return {
          status: false,
          message: errorMessage,
        };
      }
    } else if (countryTag === "State" || countryTag === "state") {
      try {
        const response: AxiosResponse<any> = await http.get<any>(
          `/v1/states/ddl?country_id=${countryId}`,
        );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";

        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getCityDDL: async (
    provinceId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    try {
      const response: AxiosResponse<any[]> = await http.get<any[]>(
        `/v1/city/ddl?province_id=${provinceId}`,
      );

      if (response.status === 200) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
  saveAccountDetails: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/accountants/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  saveNewAccountDetails: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<any>(
          `/v1/clients/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";

        return {
          status: false,
          message: errorMessage,
        };
      }
    }
    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/clients/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  simpleClientGetByIdIfClientCreatedByUser: async (
    companyAccountantName: string | null,
  ): Promise<any | IServerError | IResponse | null | any> => {
    console.log("companyAccountantName12345678", companyAccountantName);
    if (companyAccountantName) return null;
    // try {
    //   const response: AxiosResponse<any> = await http.get<any>(
    //     `/v1/clients/ddl/for-user-only`,
    //   );

    //   if (response.status === 200) {
    //     try {
    //       const clientResponse: AxiosResponse<any> = await http.get<any>(
    //         `/v1/clients/${response.data[0].value}/`,
    //       );

    //       if (clientResponse.status === 200) {
    //         // return clientResponse.data;
    //         try {
    //           const filingResourceByClient: AxiosResponse<any> =
    //             await http.get<any>(
    //               `/v1/filing-resources/get_by/client_id/?client_id=${clientResponse.data.id}`,
    //             );

    //           if (filingResourceByClient.status === 200) {
    //             // return {clientDetails:clientResponse.data, filingResource:filingResourceByClient.data, clientBank:null};
    //             try {
    //               const clientBankResponse: AxiosResponse<any> =
    //                 await http.get<any>(
    //                   `/v1/client-bank/get_by/client_id/?client_id=${clientResponse.data.id}`,
    //                 );

    //               if (clientBankResponse.status === 200) {
    //                 return {
    //                   clientDetails: clientResponse.data,
    //                   filingResource: filingResourceByClient.data,
    //                   clientBank: clientBankResponse.data,
    //                 };
    //               } else {
    //                 return {
    //                   clientDetails: clientResponse.data,
    //                   filingResource: filingResourceByClient.data,
    //                   clientBank: null,
    //                 };
    //               }
    //             } catch (error) {
    //               const axiosError = error as AxiosError;
    //               console.error("An error occurred:", axiosError);
    //               const errorMessage =
    //                 axiosError.response &&
    //                 typeof axiosError.response.data === "string"
    //                   ? axiosError.response.data
    //                   : "Unknown error";
    //               return {
    //                 status: false,
    //                 message: errorMessage,
    //               };
    //             }
    //           } else {
    //             return {
    //               clientDetails: clientResponse.data,
    //               filingResource: null,
    //               clientBank: null,
    //             };
    //           }
    //         } catch (error) {
    //           const axiosError = error as AxiosError;
    //           console.error("An error occurred:", axiosError);
    //           const errorMessage =
    //             axiosError.response &&
    //             typeof axiosError.response.data === "string"
    //               ? axiosError.response.data
    //               : "Unknown error";
    //           return {
    //             status: false,
    //             message: errorMessage,
    //           };
    //         }
    //       } else {
    //         return null;
    //       }
    //     } catch (error) {
    //       const axiosError = error as AxiosError;
    //       console.error("An error occurred:", axiosError);
    //       const errorMessage =
    //         axiosError.response && typeof axiosError.response.data === "string"
    //           ? axiosError.response.data
    //           : "Unknown error";
    //       return {
    //         status: false,
    //         message: errorMessage,
    //       };
    //     }
    //   } else {
    //     return null;
    //   }
    // } catch (error) {
    //   const axiosError = error as AxiosError;
    //   console.error("An error occurred:", axiosError);
    //   const errorMessage =
    //     axiosError.response && typeof axiosError.response.data === "string"
    //       ? axiosError.response.data
    //       : "Unknown error";
    //   return {
    //     status: false,
    //     message: errorMessage,
    //   };
    // }

    // Make it good
    try {
      // 1. Get the client id reference
      const clientList = await requestResponse<{ value: string }[]>(
        `/v1/clients/ddl/for-user-only`,
      );
      if (!clientList) return null;

      // 2. Get client details
      const clientDetails = await requestResponse<any>(
        `/v1/clients/${clientList[0].value}/`,
      );
      if (!clientDetails) return null;

      // 3. Fetch filingResource & clientBank in parallel (both depend only on clientDetails.id)
      const [filingResourceResult, clientBankResult] = await Promise.allSettled(
        [
          requestResponse<any>(
            `/v1/filing-resources/get_by/client_id/?client_id=${clientDetails.id}`,
          ),
          requestResponse<any>(
            `/v1/client-bank/get_by/client_id/?client_id=${clientDetails.id}`,
          ),
        ],
      );

      return {
        clientDetails,
        filingResource:
          filingResourceResult.status === "fulfilled"
            ? filingResourceResult.value
            : null,
        clientBank:
          clientBankResult.status === "fulfilled"
            ? clientBankResult.value
            : null,
      };
    } catch (error) {
      return {
        status: false,
        message: extractErrorMessage(error),
      };
    }
  },
  deleteClientBankById: async (
    id: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/client-bank/del_client/bank/?bank_id=${id}`,
      );

      if (response.status === 200) {
        return "Client Bank has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
  saveBankDetails: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/accountant-bank/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  saveClientBankDetails: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<any>(
          `/v1/client-bank/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return {
          status: false,
          message: errorMessage,
        };
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/client-bank/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  saveIssuerData: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse> => {
    if (requestPayload.id) {
      const response: AxiosResponse<any> | any = await http.post<any>(
        "/v1/filing-resources/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response;
      } else if (response.status === 404) {
        return response;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<any>(
        "/v1/filing-resources/",
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return { status: false, message: errorMessage, error: true };
    }
  },
  lastBankScreen: async (
    userId: string,
    tag: number,
  ): Promise<any | IServerError | IResponse | null> => {
    try {
      const response: AxiosResponse<any[]> = await http.get<any[]>(
        `/v1/user/user_detail/${userId}/update-screen/?last_bank_screen=${tag}`,
      );

      if (response.status === 200) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
};
